import storage from '@/services/storage.js'
import {
    createRouter,
    createWebHistory
} from 'vue-router'

import Main from "@/views/Main.vue";
import Home from "@/views/Home.vue"
import Login from "@/views/Login.vue"
import Profilo from "@/views/Profilo.vue"
import MiaAzienda from "@/views/MiaAzienda.vue"
import Aziende from "@/views/Aziende.vue"
import AziendaDettaglio from "@/views/AziendaDettaglio.vue"
import CommessaDettaglio from "@/views/CommessaDettaglio.vue"
import Progetti from "@/views/Progetti.vue"
import Tipologie from "@/views/admin/Tipologie.vue"
import TipiDisegno from "@/views/admin/TipiDisegno.vue"
import Aperture from "@/views/admin/Aperture.vue"
import Articoli from "@/views/Articoli.vue"
import Nodi from "@/views/Nodi.vue"
import UfLegno from "@/views/UfLegno.vue"
import Certificati from "@/views/Certificati.vue"
import Comuni from "@/views/admin/Comuni.vue"
import Province from "@/views/admin/Province.vue"
import ValoriLimite from "@/views/admin/ValoriLimite.vue"

const routes = [{
    path: "/",
    meta: {
        auth: true
    },
    component: Main,

    children: [
        {
            // Profilo personale: nessun vincolo di ruolo, ogni utente autenticato
            // gestisce i propri dati/password.
            path: "/profilo",
            component: Profilo,
        },
        {
            // Dati anagrafici e logo della propria azienda: solo l'utente Admin
            // della singola azienda collegata, mai un id arbitrario.
            path: "/mia-azienda",
            component: MiaAzienda,
            meta: {
                auth: true,
                roles: ["Admin"],
            },
        },
        {
            path: "/aziende",
            component: Aziende,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            path: "/aziende/:id",
            component: AziendaDettaglio,
            props: true,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            // Dettaglio commessa: lettura aperta a tutti i ruoli tenant, la
            // modifica è ristretta lato UI (isAdmin) e lato backend (Admin/SuperAdmin).
            path: "/commesse/:id",
            component: CommessaDettaglio,
            props: true,
            meta: {
                auth: true,
            },
        },
        {
            // Anagrafica prodotti del tenant: lettura aperta a tutti i ruoli tenant,
            // modifica ristretta lato UI (isAdmin) e lato backend (Admin/SuperAdmin).
            path: "/progetti",
            component: Progetti,
            meta: {
                auth: true,
            },
        },
        {
            // Anagrafiche globali gestite dal proprietario del sito: solo SuperAdmin.
            path: "/admin/tipologie",
            component: Tipologie,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            path: "/admin/tipi-disegno",
            component: TipiDisegno,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            path: "/admin/aperture",
            component: Aperture,
            meta: {
                auth: true,
                roles: ["SuperAdmin"],
            },
        },
        {
            // Anagrafiche di calcolo del tenant: lettura per tutti i ruoli tenant,
            // modifica ristretta lato UI e lato backend (Admin/SuperAdmin).
            path: "/articoli",
            component: Articoli,
            meta: { auth: true },
        },
        {
            path: "/nodi",
            component: Nodi,
            meta: { auth: true },
        },
        {
            path: "/uf-legno",
            component: UfLegno,
            meta: { auth: true },
        },
        {
            path: "/certificati",
            component: Certificati,
            meta: { auth: true },
        },
        {
            // Cataloghi globali (zone climatiche e limiti normativi): solo SuperAdmin.
            path: "/admin/comuni",
            component: Comuni,
            meta: { auth: true, roles: ["SuperAdmin"] },
        },
        {
            path: "/admin/province",
            component: Province,
            meta: { auth: true, roles: ["SuperAdmin"] },
        },
        {
            path: "/admin/valori-limite",
            component: ValoriLimite,
            meta: { auth: true, roles: ["SuperAdmin"] },
        },
        {
            path: "/:catchAll(.*)",
            component: Home,
        },
        {
            path: "/",
            meta: {
                auth: true
            },
            component: Home,
        },
    ]
}, {
    path: "/login",
    name: "LoginPage",
    component: Login,
}]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {

    if (to.path == "/@esci") storage.logout();

    // Controllo se è richiesta l'autenticazione. Se la destinazione non è la
    // home, la memorizzo in query così dopo il login si torna lì.
    if (to.path != "/login" && to.meta.auth && !storage.checkAuth()) {
        next({
            path: '/login',
            query: to.fullPath !== '/' ? { redirect: to.fullPath } : undefined,
        })
        return
    }
    // Controllo pagina login
    else if (to.path == "/login" && storage.checkAuth()) {

        // Se il login è stato fatto, vado alla pagina riservata
        next({
            path: '/'
        })

        return
    }

    // Controllo ruoli (RBAC lato frontend: usabilità, non è la vera barriera
    // di sicurezza, che resta il backend con [Authorize(Roles=...)])
    if (to.meta.roles && to.meta.roles.length > 0) {
        const ruolo = storage.getRole ? storage.getRole() : null
        if (ruolo && !to.meta.roles.includes(ruolo)) {
            next({ path: '/' })
            return
        }
    }

    next();

})
export default router
